<template>
  <v-btn
    :ripple="false"
    flat
    v-on:click.native="handleFontSizeChangePress"
    :aria-label="$t('TOP_BAR.BUTTON.FONT_SIZE_CHANGE')"
  >
    <v-icon>{{fontSize === "regular" || fontSize === "medium" ? "mdi-format-annotation-plus" : "mdi-format-annotation-minus"}}</v-icon>
  </v-btn>
</template>

<script>
import Vue from "vue";

export default {
  name: "FontSizeSwitch",
  props: {
    fontSize: String,
    onFontSizeChange: Function
  },
  methods: {
    handleFontSizeChangePress() {
      let newFontSize = "regular";
      switch (this.fontSize) {
        case "regular":
          newFontSize = "medium";
          break;
        case "medium":
          newFontSize = "big";
          break;
      }
      this.onFontSizeChange(newFontSize);
    }
  }
};
</script>